export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const AUTHUPDATE = 'AUTHUPDATE';
export const REGISTER = 'REGISTER';

export const CREATEBOOK = 'CREATEBOOK';
export const UPDATEBOOK = 'UPDATEBOOK';
export const DELETEBOOK = 'DELETEBOOK';
export const GETBOOK = 'GETBOOK';
export const GETALLBOOK = 'GETALLBOOK';

export const CREATEREQUEST = 'CREATEREQUEST';
export const UPDATEREQUEST = 'UPDATEREQUEST';
export const DELETEREQUEST = 'DELETEREQUEST';
export const GETREQUEST = 'GETREQUEST';

export const SENDMAIL = 'SENDMAIL';
export const SENDMULTIPLEMAILS = 'SENDMULTIPLEMAILS';

export const GETAMAZONBOOKS = 'GETAMAZONBOOKS';
export const GETCHEGGBOOKS  = 'GETCHEGGBOOKS'